import { HotToastService } from "@ngneat/hot-toast";
import { JobsService } from "./../../jobs.service";
import { FileUploadModalComponent } from "./../../../modals/file-upload-modal.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { JobFile } from "./job-file";
import { FilePreviewService } from "src/app/dashboard/main/common/file-preview.service";
import { DomSanitizer } from "@angular/platform-browser";
import { DeleteConfirmationModalComponent } from "../../../modals/delete-confirmation-modal.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";

@Component({
    selector: "app-job-upload-file",
    templateUrl: "./job-upload-file.component.html",
    styleUrls: ["./job-upload-file.component.scss"],
    imports: [TooltipModule]
})
export class JobUploadFileComponent implements OnInit {
  @Input() job: any;
  bsFileUploadModalRef: BsModalRef;
  toggleShowUploadButton: boolean = false;
  has_recurrency: boolean;

  constructor(
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private jobsService: JobsService,
    private toastr: HotToastService,
    private dashboardService: DashboardService,
    private filePreviewService: FilePreviewService,
    private sanitizer: DomSanitizer,
    private bsModalRef: BsModalRef,
  ) {}

  ngOnInit(): void {}

  getFileExt(filename) {
    if (filename !== undefined && filename !== null) {
      return filename.split(".").pop();
    } else {
      return null;
    }
  }

  openModalFileUpload(): void {
    this.bsFileUploadModalRef = this.modalService.show(
      FileUploadModalComponent,
      {
        initialState: {
          currentConversationID: this.job.uuid,
          formdataOnly: true,
          recurrency: true,
        },
      },
    );

    this.bsFileUploadModalRef.content.onUpload.subscribe((files) => {
      if (this.job.files === undefined) {
        this.job.files = [];
      }
      this.job.files = this.job.files.concat(files);

      this.job.files.forEach((file) => {
        if (file["id"] == null) {
          this.toggleShowUploadButton = true;
          let url = URL.createObjectURL(file);
          file["filename"] = file.name;
          file["url"] = url;
          file["ext"] = this.getFileExt(file.name);
          file["job"] = this.job.uuid;
          file["recurrency"] = file.recurrency;
        }
      });

      this.cdr.detectChanges();
    });
  }

  uploadFiles() {
    const formData: FormData = new FormData();

    this.job.files
      .filter((file) => file.id == null)
      .forEach((file_: JobFile) => {
        formData.append("files", file_, file_.name);
        formData.append("recurrency", JSON.stringify(file_.recurrency));
        console.log(formData.get("files"));
        console.log("RECURRENCY", formData.get("recurrency"));
      });

    this.dashboardService.show_loading.next(true);

    this.jobsService.uploadFiles(this.job.uuid, formData).then(
      (result) => {
        this.jobsService.getJob(this.job.uuid).then((job) => {
          this.job.files = job.files;
          this.cdr.detectChanges();
        });
        this.dashboardService.show_loading.next(false);
        this.toastr.success("File(s) uploaded successfully.");
        this.job.files_count++;
        this.toggleShowUploadButton = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.dashboardService.show_loading.next(false);

        this.toastr.error(
          error.error.message
            ? error.error.message
            : "Something went wrong when uploading the file(s).",
        );
      },
    );
  }

  deleteFile(file_id: number): void {
    const file = this.job.files.find(
      (file) => file.id == file_id || file.url == file_id,
    );

    if (file.id) {
      this.bsModalRef = this.modalService.show(
        DeleteConfirmationModalComponent,
        {
          initialState: {
            displayName: file.filename,
          },
        },
      );
      this.bsModalRef.content.onClose.subscribe((res) => {
        if (!res) return;
        else {
          this.dashboardService.show_loading.next(true);
          this.jobsService.deleteFile(file_id).then(
            (res) => {
              this.job.files = this.job.files.filter(
                (file) => file.id != file_id && file.url != file_id,
              );

              this.cdr.detectChanges();
              this.dashboardService.show_loading.next(false);
              this.toastr.success("File deleted successfully.");
              this.job.files_count--;
              this.cdr.detectChanges();
            },
            (error) => {
              this.dashboardService.show_loading.next(false);

              this.toastr.error(
                error.error.message
                  ? error.error.message
                  : "Something went wrong when uploading the file(s).",
              );
            },
          );
        }
      });
    } else {
      this.job.files = this.job.files.filter(
        (file) => file.id != file_id && file.url != file_id,
      );
    }
  }

  openFile(file) {
    if (file.id != null) {
      this.filePreviewService.openFile.next({
        file: file,
        disabledButtons: ["delete", "rename", "move"],
      });
    }
  }
}
